import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { AuthenticationService } from '../_services';

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    this.authenticationService.logout();
    const url = this.route.snapshot.queryParams['returnUrl'] || environment.default_return_url;
    const token = this.route.snapshot.queryParams['d'] || '';
    if(token != '')
      this.router.navigateByUrl('/login?returnUrl=' + url + '&d=' + token);
    else
      this.router.navigateByUrl('/login?returnUrl=' +  url);
  }
}
